export const helpText =
  'A sample is a lot that still depletes ingredient stock levels, but does not get logged with customs.';



// WEBPACK FOOTER //
// ./src/components/lotModalForm/constants.js